// extracted by mini-css-extract-plugin
export default {"userLogo":"UserLogo_userLogo__HHclQ","userLogoImage":"UserLogo_userLogoImage__zcaSM"};